import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { ProgressBySection } from '../progress-by-section-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<ProgressBySection> {

	return {
		rowName: { singular: 'Progress By Section', plural: 'Progress By Sections' },
		getRowKey: row => '' + row.personId + '-' + row.courseLevelId,
		stateKey: 'accelerator-progress-by-section-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
